import { TicketDetailsPage } from './TicketDetails'
import { TicketsViewType } from './TicketsViewType'

const TicketTranslationDetails = (): JSX.Element => {
  return <TicketDetailsPage viewType={TicketsViewType.Translation} />
}

export default TicketTranslationDetails
